import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-exercise-icon',
  templateUrl: './exercise-icon.component.html',
  styleUrls: ['./exercise-icon.component.scss']
})
export class ExerciseIconComponent implements OnInit {

  @Input() variant = 'outline';
  constructor() { }

  ngOnInit(): void {
  }

}
